import React from 'react';

import { PapiDeviation } from '@wix/da-papi-types';
import { StashDeviationElementPlacement, StashDeviationElementPlacementMap } from './types';
import { useStashElementPlacementMap } from './useStashElementPlacementMap';

export const StashElementPlacementContext = React.createContext<StashDeviationElementPlacementMap>({
  elementGroups: {
    adoptableBuyer: {
      groupPlacement: StashDeviationElementPlacement.NotIncluded,
      countOnBar: 0,
    },
    adoptableSeller: {
      groupPlacement: StashDeviationElementPlacement.NotIncluded,
      countOnBar: 0,
    },
  },
  deleteDeviation: StashDeviationElementPlacement.NotIncluded,
  editDeviation: StashDeviationElementPlacement.NotIncluded,
  premiumDownload: StashDeviationElementPlacement.NotIncluded,
  freeDownload: StashDeviationElementPlacement.NotIncluded,
  sellDeviation: StashDeviationElementPlacement.NotIncluded,
  copyLink: StashDeviationElementPlacement.NotIncluded,
  muroImport: StashDeviationElementPlacement.NotIncluded,
  muroOpen: StashDeviationElementPlacement.NotIncluded,
  createVideo: StashDeviationElementPlacement.NotIncluded,
  meta: {
    hasPrimaryMoreActionsMenu: false,
  },
});

interface ProviderProps {
  deviation: PapiDeviation;
  children: React.ReactNode;
}

export const StashElementPlacementContextProvider: React.FC<ProviderProps> = ({
  deviation,
  children,
}) => {
  const elementPlacementMap = useStashElementPlacementMap(deviation);
  return (
    <StashElementPlacementContext.Provider value={elementPlacementMap}>
      {children}
    </StashElementPlacementContext.Provider>
  );
};
StashElementPlacementContextProvider.displayName = 'StashElementPlacementContextProvider';
